import { InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Injection token for the API base URL.
 *
 * This token allows the API base URL to be injected rather than
 * imported directly from the environment, improving testability
 * and following the Dependency Inversion Principle.
 *
 * @example
 * // In tests, provide a mock URL:
 * { provide: API_BASE_URL, useValue: 'https://test-api.example.com' }
 *
 * @example
 * // In app.module.ts, provide the real URL:
 * { provide: API_BASE_URL, useValue: environment.apiUrl }
 */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
    providedIn: 'root',
    factory: () =>
        // Use the environment's apiUrl as fallback for tests and local development
        // In production, this should be explicitly provided in AppModule
         environment.apiUrl

});
